import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import { DateCell } from "~/shared/ui/TableV2";

const DATE_OPTIONS = ["createdAt", "updatedAt"];

export const getDnmRoleMappingsColumns = (
  t: TFunction,
  options: string[],
): ColumnsType<any> =>
  options.map((option) => ({
    title: t(`dnmRoleMappings.table.${option}`),
    dataIndex: option,
    key: option,
    render: (value: any) =>
      DATE_OPTIONS.includes(option) ? (
        <DateCell date={value} formatString="dd.MM.yyyy HH:mm" />
      ) : (
        <span>{value}</span>
      ),
  }));
